import React from 'react'
import { useWindowResizeSensor } from 'oio-react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import CustomMetadata from 'src/apps/AdminWorkspace/apps/CustomMetadata'
import ContentViewport from 'src/components/Settings/ContentViewport'
import ProtoColumnB from 'src/components/Settings/ProtoColumnB'
import ProtoColumnC from 'src/components/Settings/ProtoColumnC'
import NotFound from 'src/pages/NotFound'
import PagesHome from './Home'
import SiteAbout from './About'
import SiteBilling from './Billing'
import SiteCommerce from './Commerce'
import SiteDomain from './Domain'
import SiteEmailNotifications from './EmailNotifications'
import SiteIntegrations from './Integrations'
import SiteReports from './Reports'

const SettingsSite = () => {
   const match = useRouteMatch()
   const { currentBreakpoint } = useWindowResizeSensor()
   const currentModeHasThreeColumns = currentBreakpoint > 'd'

   return (
      <ContentViewport>
         <ProtoColumnB>
            <PagesHome />
         </ProtoColumnB>
         <Switch>
            {currentModeHasThreeColumns && (
               <Redirect
                  exact
                  from={match.url}
                  to={`${match.url}/about`}
               />
            )}
            <Route
               path={[
                  `${match.url}/about`,
                  `${match.url}/billing`,
                  `${match.url}/commerce`,
                  `${match.url}/custom-metadata`,
                  `${match.url}/domain`,
                  `${match.url}/email-notifications`,
                  `${match.url}/integrations`,
                  `${match.url}/reports`
               ]}
               render={() => (
                  <ProtoColumnC>
                     <Route
                        path={`${match.url}/about`}
                        component={SiteAbout}
                     />
                     <Route
                        path={`${match.url}/billing`}
                        component={SiteBilling}
                     />
                     <Route
                        path={`${match.url}/commerce`}
                        component={SiteCommerce}
                     />
                     <Route
                        path={`${match.url}/domain`}
                        component={SiteDomain}
                     />
                     <Route
                        path={`${match.url}/email-notifications`}
                        component={SiteEmailNotifications}
                     />
                     <Route
                        path={`${match.url}/integrations`}
                        component={SiteIntegrations}
                     />
                     <Route
                        path={`${match.url}/reports`}
                        component={SiteReports}
                     />
                     <Route
                        path={`${match.url}/custom-metadata`}
                        component={CustomMetadata}
                     />
                  </ProtoColumnC>
               )}
            />
            <Route
               path={`${match.url}/:invalid`}
               component={NotFound}
            />
         </Switch>
      </ContentViewport>
   )
}

export default SettingsSite
